import { usePictureSets } from "./usePictureSets";
import { PRODUCT_DIGITAL_FILE_UUID, PRODUCT_DIGITAL_GROUP_FILE_UUID, PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID, PRODUCT_DIGITAL_SET_UUID, usePriceList, } from "../providers/PriceListProvider";
const usePictureSetsAvailableToBuyDigitally = () => {
    const pictureSets = usePictureSets();
    const priceList = usePriceList();
    if (!pictureSets || !pictureSets.pictureSets || !priceList) {
        return [];
    }
    const digitalPortraitSetProduct = priceList.getProductByUuid(PRODUCT_DIGITAL_SET_UUID);
    const digitalPortraitProduct = priceList.getProductByUuid(PRODUCT_DIGITAL_FILE_UUID);
    const digitalMiniGroupPictureProduct = priceList.getProductByUuid(PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID);
    const digitalGroupPictureProduct = priceList.getProductByUuid(PRODUCT_DIGITAL_GROUP_FILE_UUID);
    const filteredPictureSets = pictureSets.pictureSets.reduce((pictureSets, pictureSet) => {
        const filteredPictures = pictureSet.pictures.filter((picture) => {
            if (picture.bought) {
                return false;
            }
            if (picture.pictureType == "GP" && digitalGroupPictureProduct) {
                return true;
            }
            if (picture.pictureType == "MGP" && digitalMiniGroupPictureProduct) {
                return true;
            }
            if (picture.pictureType == "IP" &&
                (digitalPortraitProduct || digitalPortraitSetProduct)) {
                if (pictureSet.bought) {
                    return false;
                }
                return true;
            }
            return false;
        });
        if (filteredPictures.length == 0) {
            return pictureSets;
        }
        const newPictureSet = Object.assign(Object.assign({}, pictureSet), { pictures: filteredPictures });
        return [...pictureSets, newPictureSet];
    }, []);
    console.log("PictureSets", filteredPictureSets);
    return filteredPictureSets;
};
export default usePictureSetsAvailableToBuyDigitally;
